import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/LiveAnnouncer/Announcer.tsx
import { useSyncExternalStore } from "react";
import { getAnnouncement, subscribeAnnouncement } from "../../../utils/announce.mjs";
import { LiveRegion } from "./LiveAnnouncer.mjs";
import { jsx } from "react/jsx-runtime";
function Announcer() {
  const message = useSyncExternalStore(subscribeAnnouncement, getAnnouncement, () => "");
  return /* @__PURE__ */ jsx(LiveRegion, { message });
}
Announcer.displayName = "Announcer";
export {
  Announcer
};
//# sourceMappingURL=Announcer.mjs.map